import React from 'react';
import useBroadcastVideoPins from '@/hooks/useBroadcastVideoPins';
import useReceiveVideoPins from '@/hooks/useReceiveVideoPins';

const VideoPinSync: React.FC = () => {
	useBroadcastVideoPins();
	useReceiveVideoPins();
	return null;
};

export default VideoPinSync;
